module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh":{"searchPlaceholder":"请输入搜索内容"},"en":{"searchPlaceholder":"Please enter search content."},"fr":{},"de":{},"jp":{},"es":{},"pt":{},"it":{},"tw":{},"kr":{}}')
  delete Component.options._Ctor
}
